<template>
<v-form ref="formSelect">
  <v-select
      v-model="item"
      :items="items"
      :label="itemAction.name"
      :item-text="itemText"
      :item-value="(itemAction.value)? itemAction.value : 'id'"
      @click:clear="onClearData()"
      clearable
      outlined
      dense>
  </v-select>
</v-form>

</template>

<script>
import axios from 'axios'
export default {
  props: ['itemAction', 'onSuccess', 'onError', 'setterModel'],
  data: () => ({
    item: null,
    items: []
  }),
  created () {
    if (this.itemAction.url) {
      this.getDinamicData(this.itemAction.url)
    }
  },
  methods: {
    itemText (item) {
      if (item && this.itemAction.nameid === 'inventarioId') {
        return `${item.descripcion.nombreEquipo}`
      } else if (this.itemAction.nameid === 'usuario_id') {
        return `${item.usuario}`
      }
      return `${item.nombre}`
    },
    getDinamicData (url) {
      const token = this.$cookies.get('token')
      axios.get(url, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
        this.items = []
        this.items.push(...response.data)
        if (this.items.length <= 0) {
          if (this.onError) this.onError(this.itemAction)
        }
        this.item = this.setterModel
      }).catch(error => {
        console.log('error', error)
        if (error == null) {
        }
      })
    },
    setModel (vals) {
      vals.map(i => {
        if (this.setterModel === i.id) {
          this.item = i
        }
      })
    },
    onClearData () {
      this.onSuccess({ id: this.itemAction.nameid, data: null, objectnameid: this.itemAction.object_name, objectdata: null })
    }
  },
  computed: {
  },
  watch: {
    item (val) {
      if (val) {
        let object = null
        this.items.map(item => {
          if (item[this.itemAction.value] === val) { object = item }
        })
        this.onSuccess({ id: this.itemAction.nameid, data: val, objectnameid: this.itemAction.object_name, objectdata: object })
      }
    }
  }

}
</script>

<style>

</style>
